import { addItemToCart } from '@/services/cart';

export const decodeHtmlEntity = (str) => {
  return str
    .replace(/&#(\d+);/g, function (match, dec) {
      return String.fromCharCode(dec);
    })
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>');
};
export function validateProductPrice(prices) {
  const discounted_percentage = prices?.discounted_percentage;
  const discounted_price = prices?.discounted_price;
  const original_price = prices?.original_price;
  const price = prices?.price;

  // Calculate discount amount if discounted_price exists
  const discount_amount = discounted_price
    ? original_price - discounted_price
    : 0;

  // Return the values in the required format
  return {
    original_price: Math.round(original_price),
    discounted_price: Math.round(discounted_price || price),
    discounted_percentage: Math.round(discounted_percentage),
    discount_amount: Math.round(discount_amount),
  };
}

export const addICartItem = async ({
  mage,
  quote,
  sku,
  qty,
  configurations = null,
}) => {
  const configurable_item_options = configurations
    ? Object.keys(configurations).reduce((acc, key) => {
        const { option_id, option_value } = configurations[key];
        acc[key] = { option_id, option_value };
        return acc;
      }, {})
    : {};

  try {
    return await addItemToCart({
      mage,
      quote,
      sku,
      qty,
      configurable_item_options: Object.values(configurable_item_options || {}),
    });
  } catch (error) {
    throw new Error(error?.message || error?.error?.message);
  }
};

export const isDiscounted = (extension_attributes) => {
  return (
    extension_attributes?.special_price !== 0 &&
    extension_attributes?.special_price < extension_attributes?.original_price
  );
};

export const filterIsInStockProducts = (products = []) => {
  return (
    products?.filter(
      (product) => product?.pg_stock?.is_in_stock && product?.pg_stock?.qty > 0
    ) || []
  );
};
